/* Safari loading, preview readiness, and stable hover previews asset v11. */
(function () {
  'use strict';

  var root = document.getElementById('product-builder');
  if (!root) return;

  document.body.classList.add('vv-custom-shop');
  document.documentElement.classList.add('vv-custom-shop-page');

  function track(name, detail) {
    window.dispatchEvent(new CustomEvent('vv:cpb-' + name, { detail: detail || {} }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'vv_cpb_' + name }, detail || {}));
  }

  track('configuration_started');

  var updateTimer;
  var previewObserver;
  var previewRootObserver;
  var lastPreviewChange = Date.now();

  function showPreviewUpdate() {
    lastPreviewChange = Date.now();
    root.classList.add('vv-cpb-preview-updating');
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(function () { root.classList.remove('vv-cpb-preview-updating'); }, 450);
  }

  function observePreview() {
    var preview = root.querySelector('.cpb-preview-layers');
    if (!preview || previewObserver) return Boolean(preview);
    previewObserver = new MutationObserver(showPreviewUpdate);
    previewObserver.observe(preview, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'style']
    });
    return true;
  }

  if (!observePreview()) {
    previewRootObserver = new MutationObserver(function () {
      if (observePreview()) previewRootObserver.disconnect();
    });
    previewRootObserver.observe(root, { childList: true, subtree: true });
  }

  var loadingShell = document.querySelector('[data-cpb-loading-shell]');
  var ready = false;
  var startedAt = Date.now();
  var MINIMUM_LOADER_TIME = 900;
  var PREVIEW_STABLE_TIME = 1200;

  function previewIsReady() {
    // CPB renders desktop previews with Konva canvases, while some mobile
    // configurations expose regular image layers. Support both renderers.
    var canvas = root.querySelector('.cpb-preview-layers canvas');
    if (canvas && canvas.width >= 240 && canvas.height >= 240) return true;

    var images = root.querySelectorAll('.cpb-preview-layers img');
    if (Array.prototype.some.call(images, function (image) {
      return image.complete && image.naturalWidth >= 240 && image.naturalHeight >= 240;
    })) return true;

    return false;
  }

  function markReady() {
    if (ready || !root.querySelector('.vv-wizard-ready')) return;
    if (Date.now() - startedAt < MINIMUM_LOADER_TIME) return;
    if (!previewIsReady() || Date.now() - lastPreviewChange < PREVIEW_STABLE_TIME) return;
    ready = true;
    window.clearInterval(readyPoll);
    root.classList.remove('vv-cpb-is-loading');
    root.classList.add('vv-cpb-is-ready');
    root.setAttribute('aria-busy', 'false');
    document.body.classList.remove('vv-custom-shop-loading');
    if (loadingShell) loadingShell.classList.add('is-ready');
    if (window.performance && window.performance.mark) window.performance.mark('vv-cpb-ready');
    window.dispatchEvent(new CustomEvent('vv:cpb-ready'));
  }

  window.addEventListener('vv:cpb-wizard-ready', markReady);
  root.addEventListener('load', markReady, true);
  var readyPoll = window.setInterval(markReady, 200);
  markReady();

  root.addEventListener('click', function (event) {
    var card = event.target.closest('.vv-wizard-card');
    if (card) track('step_opened', { step: card.dataset.step || '', label: (card.textContent || '').trim() });
    if (event.target.closest('.vv-wizard-next')) track('next_clicked');
    if (event.target.closest('.vv-wizard-size-button')) track('size_selected', { size: event.target.closest('.vv-wizard-size-button').dataset.size || '' });
    if (event.target.closest('[role="option"], .cpb-option-type-img, .cpb-option-type-text, .cpb-option-type-color, .cpb-swatch')) track('variant_selected');
  }, true);

  window.addEventListener('vv:cpb-summary-viewed', function () { track('summary_viewed'); });
  window.addEventListener('vv:cpb-add-to-cart', function () { track('add_to_cart'); });

  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  var hoverSuspended = false;
  var pointerX = null;
  var pointerY = null;
  var suspendedAtX = null;
  var suspendedAtY = null;

  function dispatchHoverExit(element) {
    if (!element) return;
    ['pointerout', 'pointerleave', 'mouseout', 'mouseleave'].forEach(function (type) {
      element.dispatchEvent(new MouseEvent(type, {
        bubbles: type === 'pointerout' || type === 'mouseout',
        cancelable: true,
        clientX: pointerX || 0,
        clientY: pointerY || 0,
        relatedTarget: document.body
      }));
    });
  }

  function suspendHoverPreview() {
    if (!finePointer || !finePointer.matches) return;

    var hoveredCards = root.querySelectorAll('.vv-wizard-card:hover');
    Array.prototype.forEach.call(hoveredCards, dispatchHoverExit);
    dispatchHoverExit(root.querySelector('.cpb-preview-layers:hover'));

    hoverSuspended = true;
    suspendedAtX = pointerX;
    suspendedAtY = pointerY;
    root.classList.add('vv-cpb-hover-suspended');
  }

  document.addEventListener('pointermove', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;

    var moved = pointerX === null ||
      Math.abs(event.clientX - pointerX) > 1 ||
      Math.abs(event.clientY - pointerY) > 1;

    pointerX = event.clientX;
    pointerY = event.clientY;

    if (!hoverSuspended || !moved) return;
    if (suspendedAtX !== null &&
        Math.abs(pointerX - suspendedAtX) <= 1 &&
        Math.abs(pointerY - suspendedAtY) <= 1) return;

    hoverSuspended = false;
    root.classList.remove('vv-cpb-hover-suspended');
  }, true);

  window.addEventListener('wheel', suspendHoverPreview, { passive: true, capture: true });
  window.addEventListener('scroll', suspendHoverPreview, { passive: true, capture: true });

}());
